import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../../store/cirt.reducers';
import { CIRTState } from '../../store/cirt.states';

import { IEmployerHistoryViewState } from './state';

export const memberPortalState = createFeatureSelector<CIRTState>(featureKey);

export const getEmployerHistoryView = createSelector(memberPortalState, (state) => state.employerHistoryViewState);

export const getBeneficiariesView_List = createSelector(
  getEmployerHistoryView,
  (state: IEmployerHistoryViewState) => state.list
);

